import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const options = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 100px;
	display: flex;
	flex-direction: column;
	background-color: ${color.interface.white};
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
	transform: translateY(105%);
	z-index: 10;
	overflow: auto;

	> p {
		font-family: nunito-light;
		font-size: 1.3rem;
		color: ${color.interface.darkgray};
		font-weight: 900;
		padding: 0.5rem;
		cursor: pointer;
		transition: all ease 0.5s;
	}

	> p:hover {
		opacity: 0.5 !important;
	}
`;
